import styled from '@xstyled/styled-components'

export const FormWrapper = styled.div``
